/**
 * Sweezy Cursors — custom mouse cursors
 *
 * Exposes no reachable web-accessible resource, but its content script injects a
 * vendor-namespaced stylesheet to restyle the cursor: `<style id="sweezy-cursors--styles">`.
 * Found with `tooling/probe-interactions.js` — it appeared on a plain bait page with no
 * user action.
 *
 * The id is vendor-named (`sweezy-cursors--`), so this identifies Sweezy specifically —
 * a useful contrast with Custom Cursor for Chrome, whose injected `<style>` is anonymous
 * and therefore not uniquely attributable (see
 * `docs/undetectable/no-observable-effect/custom-cursor-for-chrome.md`).
 *
 * Behavioural: only fires while the content script is active. Observed on version 4.0.5.
 */

import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gdcfjidbchfpojnfifkgghbamkdmbdaf';

export const sweezyCursors: ExtensionDefinition = {
  id: ID,
  name: 'Sweezy Cursors ★ Custom Cursor for Chrome™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 500_000,
  notes:
    'Detected behaviourally: injects <style id="sweezy-cursors--styles">. No reachable ' +
    'web-accessible resource; the vendor-namespaced id is the signal.',
  signals: [
    {
      id: 'dom-sweezy-styles',
      kind: 'dom',
      description:
        'Look for #sweezy-cursors--styles — the vendor-namespaced <style> element Sweezy ' +
        'injects to override the page cursor while its content script is active.',
      weight: 1,
      run: () => probeSelector('#sweezy-cursors--styles', { timeoutMs: 2000 }),
    },
  ],
};
